/*
 * Recently Viewed Products.
 * Records the current product handle to localStorage on each product page view,
 * then renders the shopper's recent products (excluding the current one) by
 * fetching the dm-recently-viewed-card section per handle via the Section
 * Rendering API. The element stays hidden until at least one card is injected.
 */
class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    const KEY = 'dm:recently-viewed';
    const MAX_STORED = 20;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    let handles = [];
    try {
      handles = JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      handles = [];
    }

    const current = this.dataset.currentHandle;
    if (current) {
      handles = [current].concat(handles.filter((h) => h !== current)).slice(0, MAX_STORED);
      try {
        localStorage.setItem(KEY, JSON.stringify(handles));
      } catch (e) {
        /* storage full / disabled — non-fatal */
      }
    }

    const limit = parseInt(this.dataset.limit || '4', 10);
    const toShow = handles.filter((h) => h && h !== current).slice(0, limit);
    if (!toShow.length) return;

    const grid = this.querySelector('.dm-recently-viewed__grid');
    if (!grid) return;

    const section = this.dataset.cardSection;
    const parser = new DOMParser();

    Promise.all(
      toShow.map((handle) =>
        fetch(`${root}products/${handle}?section_id=${section}`)
          .then((r) => (r.ok ? r.text() : ''))
          .catch(() => ''))
    ).then((parts) => {
      const frag = document.createDocumentFragment();
      parts.forEach((text) => {
        if (!text) return;
        const doc = parser.parseFromString(text, 'text/html');
        // Pull the card item out regardless of any section wrapper the API adds.
        const item = doc.querySelector('.dm-recently-viewed__item') || doc.querySelector('.card-wrapper');
        if (item) frag.appendChild(item);
      });
      if (frag.childNodes.length) {
        grid.appendChild(frag);
        this.hidden = false;
      }
    });
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
